angular.module('assets')
    .controller('AssetShowController', function ($scope, $uibModalInstance, data, Asset) {
        this.$onInit = () => {
            this.item = data;
        };

        this.cancel = () => $uibModalInstance.dismiss('Canceled');

        $scope.$on('asset.updated', () => Asset.get({id: data.id}).$promise.then(entity => this.item = entity));
    })
